import React from 'react';
import { Box } from '@mui/material';
import logo from '../../assets/images/logo-only.svg';
import styles from './ProcessingOverlay.module.scss';

interface ProcessingOverlayProps {
  message?: string;
}

const ProcessingOverlay: React.FC<ProcessingOverlayProps> = ({
  message = 'Processing your request...',
}) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <img className={styles.spin} src={logo} alt="logo" />
        <Box mt={2} fontSize="18px" fontWeight={500} color="#1E202E">
          {message}
        </Box>
      </div>
    </div>
  );
};

export default ProcessingOverlay;
